import styled from 'styled-components';
import {
  AA_SURFACE,
  AA_TEXT_PRIMARY_ON_LIGHT,
  AA_LINK_ON_LIGHT,
  AA_LINK_HOVER_ON_LIGHT,
} from '~/modules/Helper/contrast.helper';

export const Content = styled.div`
  background: ${AA_SURFACE};
  font-size: ${({ theme }) => `${14 + 2 * theme.zoomFonte}px`};
  color: ${AA_TEXT_PRIMARY_ON_LIGHT};

  a {
    color: ${AA_LINK_ON_LIGHT};
  }

  a:hover {
    color: ${AA_LINK_HOVER_ON_LIGHT};
  }
`;
